<mdb-navbar appBg="secondary" brightness="normal" SideClass="navbar navbar-dark navbar-expand-md" [containerInside]="false">
  <mdb-navbar-brand><h5 class="mb-0">{{Localization.ApplicationName | translate}}</h5></mdb-navbar-brand>
  <links>
    <ul class="navbar-nav ml-auto">
      <li class="nav-item dropdown" dropdown>
        <a appBg="secondary" brightness="normal" dropdownToggle mdbWavesEffect type="button" class="nav-link dropdown-toggle waves-light" mdbWavesEffect>
          <i class="fa fa-user-circle mr-1"></i>
          <span class="caret ml-1"></span>
        </a>
        <div *dropdownMenu class="dropdown-menu dropdown dropdown-primary dropdown-menu-right" role="menu">
          <h6 class="dropdown-header">
            <div class="mb-2"><strong>{{getUsername()}}</strong></div>
            <div><span class="pl-0">{{getUserEmail()}}</span></div>
          </h6>
          <div class="divider dropdown-divider"></div>
          <a routerLink="/signout" class="dropdown-item waves-light" mdbWavesEffect>
            <i class="fa fa-sign-out mr-1"></i>
            <span>{{Localization.Logout | translate}}</span>
          </a>
        </div>
      </li>
    </ul>
  </links>
</mdb-navbar>
<div *ngIf="!isLoading" id="page" class="w-100 d-flex justify-content-center">
  <mdb-card id="card" class="m-3">
    <mdb-card-body id="body">
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <h5 [translate]="Localization.WelcomeUser" [translateParams]="{value:getUserFirstName()}"></h5>
          <span>{{ Localization.SelectAPlatform | translate }}</span>
        </div>
        <div>
          <img id="logo" src="assets/images/chapps_logo_black.svg">
        </div>
      </div>
      <hr/>
      <div id="list" class="pt-3">
        <a *ngFor="let tile of tiles">
          <img class="clickable" [src]="tile.logoUrl" [class.enabled]="tile == activeTile" (click)="onTileClick(tile)" >
        </a>
        </div>
      <div id="description">
        <article>
          <div [style.width.%]="100 * tiles.length">
            <section *ngFor="let tile of tiles; let i = index" [style.transform]="'translateX(-' + (tile == activeTile ? i * 100 : (i + 1) * 100) + '%)'">
              <h2>{{tile.label}}</h2>
              <span>{{tile.description}}</span>
            </section>
          </div>
        </article>
      </div>
      <div class="d-flex justify-content-end mt-2">
        <button *ngIf="!activeTile.enabled" type="button"
                    mdbBtn
                    size="sm"
                    appBg="primary"
                    brightness="normal"
                    appTextColor="primary"
                    (click)="activateApplication(activeTile.type)"
                    mdbWavesEffect> {{ activeTile.activateLabel }}
        </button>
        <a *ngIf="activeTile.enabled" type="button"
                    mdbBtn
                    size="sm"
                    color="success"
                    brightness="normal"
                    appTextColor="primary"
                    [attr.href]="activeTile.url"
                    mdbWavesEffect> {{ Localization.Launch | translate }}
        </a>
      </div>
    </mdb-card-body>
  </mdb-card>
</div>
<app-application-modal (activated)="activateApplication($event)"></app-application-modal>
<div class="page-spinner" *ngIf="isLoading">
  <mdb-spinner spinnerType="big"></mdb-spinner>
</div>
